import axiosInstance from '../../../common/axios.service';
import type FILTERS from '../../../common/filters.type';
import {ADD_VEHICLE, UPDATE_VEHICLE} from './vehicle.type';

const vehiclesList = (filters?: FILTERS) => {
  return axiosInstance.get('vehicle', {params: filters}).then((response) => {
    return response;
  });
};

const addVehicle = (values: ADD_VEHICLE) => {
  return axiosInstance.post('vehicle', values).then((response) => {
    return response;
  });
};

const updateVehicle = (values: {id: number; payload: UPDATE_VEHICLE}) => {
  return axiosInstance.put(`vehicle/${values.id}`, values.payload).then((response) => {
    return response;
  });
};

const VehicleServices = {
  vehiclesList,
  addVehicle,
  updateVehicle,
};

export default VehicleServices;
